
const Pagination = {
    // total:this.state.pageDate.total,
    pageSize:20,
    showTotal:(total, range) => `当前${range[0]}-${range[1]}条 总数${total}条`,
    // current:this.state.pageDate.page,
    // onChange:this.pageChange,
    showQuickJumper:true,
    showSizeChanger: true
 };







export default Pagination;


// WEBPACK FOOTER //
// ./utils/Pagination.js